import React, { Component } from 'react';
import { IntlProvider, addLocaleData } from "react-intl";
import frLocaleData from "react-intl/locale-data/fr";
import enLocaleData from "react-intl/locale-data/en";
import translations from "./i18n/locales"
import App from "./App";

addLocaleData(frLocaleData);
addLocaleData(enLocaleData);

class AppWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      lang: "fr"
    }
  }

  toggleLang = (lang) => {
    this.setState({
      lang: lang
    })
  }
  render() {
    const locale = window.location.search.replace("?locale=","") || this.state.lang
    const messages = translations[locale];
    return (
      <IntlProvider locale={locale} key={locale} messages={messages}>
        <App
          handleLang={(lang) => this.toggleLang(lang)}
          lang={this.state.lang}
        />
      </IntlProvider>
    );
  }
}
export default AppWrapper



// WEBPACK FOOTER //
// ./src/AppWrapper.js